import React from 'react';
import config from 'config';
import {DocumentList} from 'components/documents';

const UserInfoList = ({ user }) => (
  <DocumentList>
    <li>ПІБ: <strong>{user.get('last_name')} {user.get('first_name')} {user.get('middle_name')}</strong></li>
    <li>Пошта: <strong>{user.get('email') ? user.get('email') : "Не вказано"}</strong></li>
    <li>Телефон: <strong>{user.get('phone') ? user.get('phone') : "Не вказано"}</strong></li>
    <li>Адреса: <strong>{user.get('address') ? user.get('address') : "Не вказано"}</strong></li>
    <li>Дата реєстрації: <strong>{new Date(user.get('date_joined')).toLocaleString('uk-UA', config.options)}</strong></li>
    <li><strong></strong></li>
  </DocumentList>
)

export default UserInfoList;



// WEBPACK FOOTER //
// ./src/cabinet/user/user-info.js